export default {
  getNameForFigure(fig) {
    const names = {
      '1101': 'Puer',
      '1010': 'Amissio',
      '0010': 'Albus',
      '0000': 'Populus',
      '0011': 'Fortuna Major',
      '0110': 'Conjunctio',
      '1011': 'Puella',
      '0100': 'Rubeus',
      '0101': 'Acquisitio',
      '1001': 'Carcer',
      '0001': 'Tristitia',
      '1000': 'Laetitia',
      '1110': 'Cauda Draconis',
      '0111': 'Caput Draconis',
      '1100': 'Fortuna Minor',
      '1111': 'Via',
    }

    let nameKey = ''

    nameKey += fig.fire ? '1' : '0'
    nameKey += fig.air ? '1' : '0'
    nameKey += fig.water ? '1' : '0'
    nameKey += fig.earth ? '1' : '0'

    return names[nameKey]
  },
}
